import { LanguageType } from '@/custom-types';
import { IncidentStatusOption } from '@/graphql/generated';

export const incidentStatusOptionMapper = (type: IncidentStatusOption, language: LanguageType) => {
  const texts: Record<LanguageType, Record<IncidentStatusOption, string>> = {
    en: {
      [IncidentStatusOption.New]: 'New',
      [IncidentStatusOption.Pending]: 'Pending',
      [IncidentStatusOption.Assigned]: 'Assigned',
      [IncidentStatusOption.Scheduled]: 'Scheduled',
      [IncidentStatusOption.Resolved]: 'Resolved',
      [IncidentStatusOption.Completed]: 'Completed',
      [IncidentStatusOption.Cancelled]: 'Cancelled',
    },
    es: {
      [IncidentStatusOption.New]: 'Nuevo',
      [IncidentStatusOption.Pending]: 'Pendiente',
      [IncidentStatusOption.Assigned]: 'Externalizado',
      [IncidentStatusOption.Scheduled]: 'Agendado',
      [IncidentStatusOption.Resolved]: 'Trabajo Realizado',
      [IncidentStatusOption.Completed]: 'Completado',
      [IncidentStatusOption.Cancelled]: 'Cancelado',
    },
  }

  return texts[language][type]
}
